import { createContext, use, useCallback, useState } from 'react';
import { post } from 'api';
import { removeItemFromStore } from 'lib/utils';
// import { firebaseAuth } from 'services/firebase/firebase';
import { requestPermission } from 'services/firebase/getPermission';

// import socket from '../../socket.js';

export const AuthJwtContext = createContext({});

const AuthJwtProvider = ({ children }) => {
  const [sessionUser, setSessionUser] = useState(null);

  const setSession = useCallback(
    async (user, token) => {
      setSessionUser(user);
      if (token) {
        localStorage.setItem('auth_token', token);
      }
      const fcmWebToken = await requestPermission();
      await post('users/sendToken', { type: 'web', fcmWebToken });
    },
    [setSessionUser],
  );

  const signout = useCallback(() => {
    setSessionUser(null);
    removeItemFromStore('session_user');
    removeItemFromStore('auth_token');
  }, [setSessionUser, sessionUser]);

  return (
    <AuthJwtContext value={{ sessionUser, setSessionUser, setSession, signout }}>
      {children}
    </AuthJwtContext>
  );
};

export const useAuth = () => use(AuthJwtContext);

export default AuthJwtProvider;
